export default __webpack_public_path__ + "static/Phone-Holder-For-Travel-7ba4c07848cdb583c8e2eead4431d3e6.jpg";